const state = {
  notificacao: '',
}

const getters = {
  notificacao: state => {
    return state.notificacao
  }
}

const mutations = {
  setNotificacao (state, value) {
    state.notificacao = value
  }
}

const actions = {
  setNotificacao (context, value) {
    context.commit('setNotificacao', value)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/notificacao.js